import Vue from "vue";
import Announcements from "./Announcements.vue";

export function load() {
  const selector = "announcements-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(Announcements, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
